import { FluentResource } from '@fluent/bundle';
import { makeStringIds } from './localization-string-util';

export enum PluginManagementStrings {
    text_body_loadingPlugins,
    text_body_noInstalledPlugins,
    text_header_plugins

}

export const pluginManagementStrings = makeStringIds<typeof PluginManagementStrings>('pluginManagement', PluginManagementStrings);

export function  getPluginManagementFluentResource(): FluentResource {
    // Translation can be done by assigning a string to each property
    // in the pluginManagementStrings object created above.
    return new FluentResource('');
}

